import React from "react";

const ShareSvg = ({ className }) => {
  return (
    <svg
      className={["ShareSvg", className ? className : undefined].join(" ")}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g id="ios_share_black_24dp (3)">
        <g id="Group">
          <path
            id="Path"
            d="M18 8H16C15.45 8 15 8.45 15 9C15 9.55 15.45 10 16 10H18V20H6V10H8C8.55 10 9 9.55 9 9C9 8.45 8.55 8 8 8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8Z"
            fill="#154F9C"
          />
          <path
            id="Path_2"
            d="M11.9997 15C12.5497 15 12.9997 14.55 12.9997 14V5.99996H14.7897C15.2397 5.99996 15.4597 5.45996 15.1397 5.14996L12.3497 2.35996C12.1497 2.15996 11.8397 2.15996 11.6397 2.35996L8.8497 5.14996C8.5397 5.45996 8.7597 5.99996 9.2097 5.99996H10.9997V14C10.9997 14.55 11.4497 15 11.9997 15Z"
            fill="#154F9C"
          />
        </g>
      </g>
    </svg>
  );
};

export default ShareSvg;
